import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import Spinner from '~/components/Spinner';

import {
  loadPreliminaryEquipments,
  loadPreliminaryEquipmentsByRace,
} from './actions';
import {
  selectError,
  selectLoading,
  selectPreliminaryEquipments,
} from './selectors';

const mapStateToProps = (state, props) => ({
  loading: selectLoading(state, props),
  error: selectError(state, props),
  equipChanges: props.selector
    ? props.selector(state, props)
    : selectPreliminaryEquipments(state, props),
});

function mapDispatchToProps(dispatch) {
  return {
    loadPreliminaryEquipments: round =>
      dispatch(loadPreliminaryEquipments(round)),
    loadPreliminaryEquipmentsByRace: race =>
      dispatch(loadPreliminaryEquipmentsByRace(race)),
  };
}

const PreliminaryEquipments = ({
  round,
  race,
  render,
  equipChanges,
  loadPreliminaryEquipments,
  loadPreliminaryEquipmentsByRace,
  ...props
}) => {
  useEffect(() => {
    if (!equipChanges) {
      if (round) {
        loadPreliminaryEquipments(round);
      } else if (race) {
        loadPreliminaryEquipmentsByRace(race);
      }
    }
  }, [
    equipChanges,
    round,
    race,
    loadPreliminaryEquipments,
    loadPreliminaryEquipmentsByRace,
  ]);

  return <Spinner {...props}>{equipChanges && render(equipChanges)}</Spinner>;
};

PreliminaryEquipments.propTypes = {
  round: PropTypes.string,
  race: PropTypes.string,
  render: PropTypes.func.isRequired,
};

PreliminaryEquipments.defaultProps = {
  equipChanges: undefined,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreliminaryEquipments);
